import { free_return_shipping, Icon, stock_package, wallet } from '../../components/Icon/Icon';
import { ApiProduct } from '../../types';
import { DeliveryTime } from './DeliveryTime';
import { StockKeepingMessage } from './StockKeepingMessage';
import './DeliveryDetails.css';
import { useTranslation } from '../../i18n/i18n';
import { useConfig } from '../../config';

export function DeliveryDetails({ product }: { product: ApiProduct }) {
	const t = useTranslation().product;

	const store = useConfig().store;

	const freeReturns = store == 'kgse' && product.vendorId == 25 && product.stocked;

	return (
		<>
			<div className="delivery-details">
				{product.deliveryClass != 3 && product.deliveryClass != 4 && product.deliveryNotice == '' && (
					<div className="stock-status">
						<Icon
							size={19}
							shape={stock_package}
							className={`${product.deliveryClass === 6 ? 'sold-out' : ''}`}
						/>
						<span>
							<StockKeepingMessage product={product} />
						</span>
					</div>
				)}
				{freeReturns && (
					<div className="return-notice">
						<Icon size={19} shape={free_return_shipping} />
						<span>{t.freeReturnShipping}</span>
					</div>
				)}
				<div
					className={
						product.deliveryClass == 3 || product.deliveryClass == 4 || product.deliveryNotice != ''
							? 'stock-status'
							: 'delivery-time'
					}
				>
					<DeliveryTime
						deliveryNotice={product.deliveryNotice}
						deliveryClass={product.deliveryClass}
						textLength={'long'}
						iconSize={19}
					/>
				</div>
				<div className={freeReturns ? '' : 'return-notice '}>
					<Icon size={19} shape={wallet} />
					<span>{t.payWithKlarnaOrSwish}</span>
				</div>
			</div>
		</>
	);
}
